const apiURL =
  process.env.REACT_APP_ENV === 'development'
    ? 'http://localhost:4000'
    : process.env.REACT_APP_API_URL || 'https://api.aioverse.aiomotors.com';

export default apiURL;
